import React from "react";
import { useHistory } from "react-router-dom";
import SeloReclameAqui from "components/SeloReclameAqui";

// Rodapé da página inicial nova (com o selo do Reclame Aqui), usado também na /tv.
export default function Rodape() {
  const history = useHistory();

  return (
    <footer>
      <div className="wrap">
        <div className="foot-grid">
          <div>
            <img className="foot-logo" src="/icons/logo_lancamento.svg" alt="JoinKids" />
            <p className="foot-tag">A infância segura em qualquer tela. Conteúdo cristão para os pequeninos.</p>
            <div className="social">
              <a href="https://www.instagram.com/joinkidsbrasil" target="_blank" rel="noopener noreferrer" aria-label="Instagram da JoinKids"><img src="/icons/insta.svg" alt="Instagram" /></a>
              <a href="https://www.facebook.com/joinkidsbrasil" target="_blank" rel="noopener noreferrer" aria-label="Facebook da JoinKids"><img src="/icons/face.svg" alt="Facebook" /></a>
            </div>
          </div>
          <div>
            <h4>Plataforma</h4>
            <a href="#planos">Assinar</a>
            <button className="lp-linkbtn" onClick={() => history.push("/login")}>Entrar</button>
            <a href="#planos">Ver planos</a>
          </div>
          <div>
            <h4>Conteúdos</h4>
            <a href="/conteudos">Desenhos</a>
            <a href="/conteudos">Músicas</a>
            <a href="/conteudos">Histórias bíblicas</a>
          </div>
          <div>
            <h4>Contato</h4>
            <a href="https://wa.me/5592982168732" target="_blank" rel="noopener noreferrer">WhatsApp (92) 98216-8732</a>
            <a href="mailto:atendimento@joinkids.com.br">atendimento@joinkids.com.br</a>
            <a href="#faq">Central de ajuda</a>
          </div>
        </div>
        <SeloReclameAqui estilo={{ display: "flex", justifyContent: "center", margin: "0 0 16px" }} />
        <div className="foot-bottom">© 2026 JoinKids. Todos os direitos reservados.</div>
      </div>
    </footer>
  );
}
